import React, { useRef, useState } from "react";
import config from "../config";
import {
  FaCalendarAlt,
  FaCar,
  FaCheck,
  FaCircle,
  FaList,
} from "react-icons/fa";
import { MdLocalCarWash } from "react-icons/md";
import { IoIosArrowBack } from "react-icons/io";
import { Bounce, toast } from "react-toastify";
import { purchaseSubscription } from "../api/subscriptionApi";
import { useAuth } from "../context/AuthContext";
import SubscribeConfirmation from "./Modal/SubscribeConfirmation";
import CouponModal from "./Modal/CounponModal";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import i18next from "i18next";
const SubscriptionDetails = ({ subscription, isShowSubDetails, onHide }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { clientData, refreshClient } = useAuth();
  const [selected, setSelected] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCouponModalOpen, setCouponModalOpen] = useState(false);
  const [coupon, setCoupon] = useState(null);

  const handleCouponConfirm = (coupon) => {
    console.log("Confirmed Coupon:", coupon);
    localStorage.setItem("coupon", JSON.stringify(coupon));
    setCoupon(coupon);
  };

  const {
    name_en,
    name_ar,
    description_en,
    description_ar,
    icon,
    color,
    cost,
    duration_days,
    subscriptionServices,
    number_of_cars,
    number_of_washes,
    one_year_offer,
  } = subscription;
  let payload = useRef();
  if (!subscription) return;

  const handleButtonClick = () => {
    if (!clientData) {
      // Not logged in: Save subscription to localStorage and redirect to login
      localStorage.setItem(
        "selectedSubscription",
        JSON.stringify(subscription)
      );
      navigate("/login", {
        state: { redirectTo: "/", showSubscription: true },
      });
      return;
    }

    const cost = selected ? subscription.cost : subscription.one_year_offer;
    const start_date = new Date();
    const duration_days = selected ? subscription.duration_days : 365; // One year for one_year_offer
    const end_date = new Date(start_date);
    end_date.setDate(end_date.getDate() + duration_days);
    payload.current = {
      client_id: clientData.client_id,
      subscription_id: subscription.subscription_id,
      subscription_name: subscription?.name_en,
      subscription_cost: cost,
      subscription_features: JSON.stringify({
        number_of_cars: subscription.number_of_cars,
        number_of_washes: subscription?.number_of_washes,
        color: subscription?.color,
        subscriptionServices: subscription?.subscriptionServices,
      }),
      start_date: start_date,
      end_date: end_date,
      created_date: start_date,
      payment_status: "Pending",
    };
    setIsModalOpen(true);
     
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const handleConfirm = () => {
    setIsModalOpen(false);
    handlePurchase();
  };

  const handlePurchase = async () => {
    const cost = selected ? subscription.cost : subscription.one_year_offer;
    const start_date = new Date();
    const duration_days = selected ? subscription.duration_days : 365; // One year for one_year_offer
    const end_date = new Date(start_date);
    end_date.setDate(end_date.getDate() + duration_days);
    payload.current = {
      client_id: clientData.client_id,
      subscription_id: subscription.subscription_id,
      subscription_name: subscription?.name_en,
      subscription_cost: cost,
      subscription_features: JSON.stringify({
        duration_days:duration_days,
        number_of_cars: subscription.number_of_cars,
        number_of_washes: subscription?.number_of_washes,
        color: subscription?.color,
        subscriptionServices: subscription?.subscriptionServices,
      }),
      start_date: start_date,
      end_date: end_date,
      created_date: start_date,
      payment_status: "Pending",
    };

    try {
      setIsProcessing(true);
      const result = await purchaseSubscription(payload.current); // Call API to purchase subscription
      console.log("purchaseSubscription", result);
      toast.success(t("subpurchasesuccess"), {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      localStorage.setItem("actionType", "SUBSCRIBE");
      navigate("/payment", {
        state: {
          subscription: {
            client_subscription_id: result?.clientSubscription?.client_subscription_id,
            client_id: result?.clientSubscription?.client_id,
            subscription_id: subscription?.subscription_id,
            subscription_name: subscription?.name_en,
            subscription_cost: cost,
            duration_days: duration_days,
            number_of_cars: subscription.number_of_cars,
            number_of_washes: subscription?.number_of_washes,
            subscriptionServices: subscription?.subscriptionServices,
            coupon: coupon,
          },
        },
      });
      onHide();
      refreshClient(clientData.client_id);
    } catch (error) {
      toast.error(t("subpurchaseerror") + error.message, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setIsProcessing(false);
    }
  };

  return (
<div
      className={`min-h-screen bg-gradient-to-b from-white to-blue-200 transition-transform duration-300  ${
        isShowSubDetails ? "translate-x-0" : "translate-x-full"
      } `}
      dir={i18next.language === "ar" ? "rtl" : "ltr"}
    >
      {/* Header */}
      <div className="bg-white border-t-[5px] border-[#FFCC70] shadow-lg sticky top-0 z-10 rounded-lg">
        <div className="max-w-7xl mx-auto  flex items-center p-4 relative">
          <button
            onClick={onHide}
            className={`rounded-full p-2 bg-gray-100 hover:bg-gray-200 transition-colors   ${i18n.dir() === "rtl" ? "-scale-x-100" : ""}`}
          >
            <IoIosArrowBack className="text-gray-600" />
          </button>
          <h1 className="text-[#1D5761] text-2xl font-bold flex-1 text-center">
            {i18n.dir() === "rtl" ? name_ar : name_en?.toUpperCase()}
          </h1>
          <div className="w-10"></div> {/* Spacer for centering */}
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-2xl mx-auto p-2 p-2">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          
          {/* Left Section - Details (Mobile: Full width, Desktop: 2/3) */}
          <div className="lg:col-span-2 space-y-6">
            
            {/* Description */}
            <div className="bg-white rounded-lg p-6 shadow-lg">
              <h2 className="text-xl font-bold text-gray-800 mb-4">{t("PackageDetails")}</h2>
              <p className="text-gray-600 leading-relaxed">
                {i18n.dir() === "rtl" ? description_ar : description_en}
              </p>
            </div>

            {/* Features Grid */}
            <div className="bg-white rounded-lg p-6 shadow-lg">
              <h2 className="text-xl font-bold text-gray-800 mb-6">{t("WhatsIncluded")}</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                
                {/* Number of Washes */}
                <div className="flex gap-4 p-4 bg-gray-50 rounded-lg">
                  <div className="flex items-center justify-center w-12 h-12 bg-blue-100 rounded-full flex-shrink-0">
                    <MdLocalCarWash className="text-xl text-blue-600" />
                  </div>
                  <div className="flex flex-col justify-center">
                    <div className="text-lg font-semibold text-gray-800">
                      {number_of_washes || t("unlimited")}
                    </div>
                    <div className="text-sm text-gray-500">
                      {t("numberofwashes")}
                    </div>
                  </div>
                </div>

                {/* Number of Cars */}
                <div className="flex gap-4 p-4 bg-gray-50 rounded-lg">
                  <div className="flex items-center justify-center w-12 h-12 bg-green-100 rounded-full flex-shrink-0">
                    <FaCar className="text-xl text-green-600" />
                  </div>
                  <div className="flex flex-col justify-center">
                    <div className="text-lg font-semibold text-gray-800">
                      {number_of_cars || t("unlimited")}
                    </div>
                    <div className="text-sm text-gray-500">
                      {t("numberofcars")}
                    </div>
                  </div>
                </div>

                {/* Duration */}
                <div className="flex gap-4 p-4 bg-gray-50 rounded-lg">
                  <div className="flex items-center justify-center w-12 h-12 bg-orange-100 rounded-full flex-shrink-0">
                    <FaCalendarAlt className="text-xl text-orange-600" />
                  </div>
                  <div className="flex flex-col justify-center">
                    <div className="text-lg font-semibold text-gray-800">
                      {duration_days} {t("days")}
                    </div>
                    <div className="text-sm text-gray-500">
                      {t("duration")}
                    </div>
                  </div>
                </div>

                {/* Services */}
                <div className="flex gap-4 p-4 bg-gray-50 rounded-lg">
                  <div className="flex items-center justify-center w-12 h-12 bg-purple-100 rounded-full flex-shrink-0">
                    <FaList className="text-xl text-purple-600" />
                  </div>
                  <div className="flex flex-col justify-center">
                    <div className="text-lg font-semibold text-gray-800">
                       {t("services")}
                    </div>
                    <div className="text-sm text-gray-500">
                     {subscriptionServices?.length || 0 } {t("Availableservices")}
                    </div>
                  </div>
                </div>
              </div>

              {/* Services List */}
              {subscriptionServices && subscriptionServices.length > 0 && (
                <div className="mt-6 p-4 bg-blue-50 rounded-lg">
                  <h3 className="font-semibold text-gray-800 mb-3">{t("services")}</h3>
                  <ul className="space-y-2">
                    {subscriptionServices.map((service, index) => (
                      <li key={index} className="flex items-center text-gray-700">
                        <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                        {i18n.dir() === "rtl"
                          ? service.serviceType.name_ar
                          : service.serviceType.name_en}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>

          {/* Right Section - Pricing (Mobile: Full width below, Desktop: 1/3 sidebar) */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow-lg sticky top-24">
              
              {/* Order Summary Header */}
              <div className="p-6 border-b border-gray-200">
                <h2 className="text-xl font-bold text-gray-800">{t("OrderSummary")}</h2>
              </div>

              {/* Pricing Options */}
              <div className="p-6 space-y-4">
                
                {/* Regular Price Option */}
                <div
                  className={`border-2 rounded-lg p-4 cursor-pointer transition-all ${
                    selected 
                      ? "border-green-500 bg-green-50" 
                      : "border-gray-200 hover:border-gray-300"
                  }`}
                  onClick={() => setSelected(!selected)}
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      {selected ? (
                        <FaCheck className="text-green-600 text-lg" />
                      ) : (
                        <FaCircle className="text-gray-400 text-lg" />
                      )}
                      <div>
                        <div className="font-semibold text-gray-800">{t("MonthlyPlan")}</div>
                        <div className="text-sm text-gray-500">{t("Paymonthly")}</div>
                      </div>
                    </div>
                    <div className="text-2xl font-bold text-gray-800">
                      {parseFloat(cost).toFixed(0)} <span className="text-sm">QAR</span>
                    </div>
                  </div>
                </div>

                {/* Annual Price Option */}
                <div
                  className={`border-2 rounded-lg p-4 cursor-pointer transition-all ${
                    !selected 
                      ? "border-blue-500 bg-blue-50" 
                      : "border-gray-200 hover:border-gray-300"
                  }`}
                  onClick={() => setSelected(!selected)}
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      {!selected ? (
                        <FaCheck className="text-blue-600 text-lg" />
                      ) : (
                        <FaCircle className="text-gray-400 text-lg" />
                      )}
                      <div>
                        <div className="font-semibold text-gray-800">{t("AnnualPlan")}</div>
                        <div className="text-sm text-green-600 font-medium">{t("Savemoney")}</div>
                      </div>
                    </div>
                    <div className="text-2xl font-bold text-gray-800">
                      {one_year_offer} <span className="text-sm">QAR</span>
                    </div>
                  </div>
                </div>

                {/* Coupon Section */}
                <div className="border-t border-gray-200 pt-4">
                  <button
                    onClick={() => {
                      setCoupon(null);
                      setCouponModalOpen(true);
                    }}
                    className="w-full bg-blue-100 hover:bg-blue-200 text-blue-700 font-semibold py-3 px-4 rounded-lg transition-colors"
                  >
                    {coupon
                      ? `Applied: ${coupon.discount_type === "percentage"
                          ? `${coupon.discount_value}% OFF`
                          : `${coupon.discount_value} QAR OFF`}`
                      : t("applycoupon")}
                  </button>
                </div>

                {/* Total */}
                <div className="border-t border-gray-200 pt-4">
                  <div className="flex justify-between items-center mb-4">
                    <span className="text-lg font-semibold text-gray-800">Total</span>
                    <span className="text-2xl font-bold text-gray-800">
                      {selected ? parseFloat(cost).toFixed(0) : one_year_offer} QAR
                    </span>
                  </div>
                  
                  {/* Subscribe Button */}
                  <button
                    onClick={handleButtonClick}
                    className="w-full bg-orange-400 hover:bg-orange-500 text-white font-bold py-4 px-6 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-lg"
                    disabled={isProcessing}
                  >
                    {isProcessing ? t("processing") : t("subscribe")}
                  </button>
                </div>
              </div>

              {/* Decorative Element */}
              <div className="flex justify-center p-4">
                <svg
                  className="w-8 h-8 opacity-50"
                  viewBox="0 0 87 87"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="#FFCC70"
                    d="M39.5896 76.1436L36.4191 65.5644C33.6712 56.4664 26.5903 49.3783 17.5013 46.6277L6.93278 43.454C3.02241 42.2903 3.02241 36.7891 6.93278 35.6254L17.5013 32.4516C26.5903 29.701 33.6712 22.613 36.4191 13.5149L39.5896 2.93572C40.7522 -0.978574 46.2478 -0.978574 47.4104 2.93572L50.5809 13.5149C53.3288 22.613 60.4097 29.701 69.4987 32.4516L80.0672 35.6254C83.9776 36.7891 83.9776 42.2903 80.0672 43.454L69.4987 46.6277C60.4097 49.3783 53.3288 56.4664 50.5809 65.5644L47.4104 76.1436C46.2478 79.9521 40.7522 79.9521 39.5896 76.1436Z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SubscribeConfirmation
        payload={payload.current}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirm}
      />
      <CouponModal
        isOpen={isCouponModalOpen}
        onClose={() => setCouponModalOpen(false)}
        onConfirm={handleCouponConfirm}
      />
    </div>
  );
};

export default SubscriptionDetails;
